import React, { useCallback, useContext } from "react"
import { useTranslation } from "react-i18next"
import * as Components from "../../components/components"
import { getPaymentMeansOptions } from "../../constants"

import { EventBus } from "../../eventbus"
import Ueberweisung from "../../models/ueberweisung"
import { FeatureService } from "../../services/FeatureService"
import { AbweichenderZahlungsempfaengerView } from "../AbweichenderZahlungsempfaengerView"
import { UeberweisungenView } from "../UeberweisungenView"
import { ZahlungsbedingungenEinfachListView } from "./einfach/ZahlungsbedingungenEinfachListView"
import { ConfigContext } from "../../contexts/CustomConfigContext"
import { useStoreRechnung } from "../../store"

export function ZahlungsdatenView() {
    const { t } = useTranslation()
    const config = useContext(ConfigContext)
    const { zahlungsdaten } = useStoreRechnung("zahlungsdaten")

    const paymentMeanOptions = getPaymentMeansOptions()

    const onChange = useCallback(
        (element: string) => (value: unknown) => {
            EventBus.instance.emit("changeProperty", `zahlungsdaten.${element}`, value)
        },
        [],
    )

    const onChangeZahlungsmittel = useCallback(
        (value: unknown) => {
            onChange("zahlungsmittelCode")(value)

            EventBus.instance.emit("changeProperty", `zahlungsdaten.ueberweisung`, [new Ueberweisung()])
            EventBus.instance.emit("changeProperty", `zahlungsdaten.sepaGlaeubigerID`, "")
            EventBus.instance.emit("changeProperty", `zahlungsdaten.sepaIbanKonto`, "")
            EventBus.instance.emit("changeProperty", `zahlungsdaten.sepaMandatsreferenz`, "")
        },
        [onChange],
    )

    return (
        <Components.Collapsible title={t("rechnung.zahlungsdaten.title")} collapsed={false}>
            {config?.skontoAlsText && (
                <Components.FormGroup label={t("rechnung.zahlungsdaten.zahlungsbedingungen.title")}>
                    <ZahlungsbedingungenEinfachListView />
                </Components.FormGroup>
            )}

            <Components.FormGroup label={t("rechnung.zahlungsdaten.zahlungsmittelCode.label")}>
                <Components.MultiSelect
                    placeholder={t("rechnung.zahlungsdaten.zahlungsmittelCode.placeholder")}
                    onChange={onChangeZahlungsmittel}
                    value={paymentMeanOptions.find((v) => v.value === zahlungsdaten.zahlungsmittelCode)}
                    options={paymentMeanOptions}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.zahlungsdaten.verwendungszweck.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.zahlungsdaten.verwendungszweck.placeholder")}
                    onChange={(v) => onChange("verwendungszweck")(v)}
                    value={zahlungsdaten.verwendungszweck}
                />
            </Components.FormGroup>

            {["58"].includes(zahlungsdaten.zahlungsmittelCode) ? (
                <UeberweisungenView ueberweisung={zahlungsdaten.ueberweisung} t={t} />
            ) : ["59"].includes(zahlungsdaten.zahlungsmittelCode) ? (
                <>
                    <Components.FormGroup label={t("rechnung.zahlungsdaten.sepaMandatsreferenz.label")}>
                        <Components.TextEdit
                            placeholder={t("rechnung.zahlungsdaten.sepaMandatsreferenz.placeholder")}
                            onChange={onChange("sepaMandatsreferenz")}
                            value={zahlungsdaten.sepaMandatsreferenz}
                        />
                    </Components.FormGroup>
                    <Components.FormGroup label={t("rechnung.zahlungsdaten.sepaGlaeubigerID.label")}>
                        <Components.TextEdit
                            placeholder={t("rechnung.zahlungsdaten.sepaGlaeubigerID.placeholder")}
                            onChange={(v) => onChange("sepaGlaeubigerID")(v)}
                            value={zahlungsdaten.sepaGlaeubigerID}
                        />
                    </Components.FormGroup>
                    <Components.FormGroup label={t("rechnung.zahlungsdaten.sepaIbanKonto.label")}>
                        <Components.TextEdit
                            placeholder={t("rechnung.zahlungsdaten.sepaIbanKonto.placeholder")}
                            onChange={(v) => onChange("sepaIbanKonto")(v)}
                            value={zahlungsdaten.sepaIbanKonto}
                        />
                    </Components.FormGroup>
                </>
            ) : (
                <></>
            )}
            {!FeatureService.isFeatureActive("DEMO") && <AbweichenderZahlungsempfaengerView basePath="zahlungsdaten.abweichenderZahlungsempfaenger" />}
        </Components.Collapsible>
    )
}
